import { useState,useEffect } from "react";
import api from "../axios";

export default function AddReviews({
  hotelId,
  campingId,
  villaId,
  onReviewAdded
}) {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [alreadyReviewed, setAlreadyReviewed] = useState(false);

  useEffect(() => {
  checkReview();
}, []);

const checkReview = async () => {
  let type = null;
  let targetId = null;

  if (hotelId) {
    type = "hotel";
    targetId = hotelId;
  } else if (campingId) {
    type = "camping";
    targetId = campingId;
  } else if (villaId) {
    type = "villa";
    targetId = villaId;
  }

  const res = await api.get(`/reviews/check?type=${type}&targetId=${targetId}`);

  setAlreadyReviewed(res.data.reviewed);
};

  const submitReview = async () => {

    let type = null;
    let targetId = null;

    if (hotelId) {
      type = "hotel";
      targetId = hotelId;
    } else if (campingId) {
      type = "camping";
      targetId = campingId;
    } else if (villaId) {
      type = "villa";
      targetId = villaId;
    }

    if (!type || !targetId) {
      alert("Invalid review target");
      return;
    }

    try {
      setLoading(true);

      await api.post(
        "/reviews",
        {
          type,
          targetId,
          rating,
          comment
        }
      );

      setComment("");
      setRating(5);
      onReviewAdded?.();
      alert("Review submitted successfully");
    } catch (err) {
      alert(err.response?.data?.msg || "Failed to submit review");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-5 rounded-xl shadow border">
      {
        alreadyReviewed ? (<><div className="bg-green-50 border border-green-200 p-4 rounded">
          You Already Submitted a Review for this property.
        </div> </>):(<><h3 className="font-heading text-lg mb-3">Write a Review</h3>

      {/* STAR RATING */}
      <select
        value={rating}
        onChange={(e) => setRating(Number(e.target.value))}
        className="border p-2 rounded w-full mb-3"
      >
        {[5, 4, 3, 2, 1].map((r) => (
          <option key={r} value={r}>
            {r} Star{r > 1 && "s"}
          </option>
        ))}
      </select>

      {/* COMMENT */}
      <textarea
        className="w-full border p-3 rounded"
        rows="4"
        placeholder="Share your experience"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />

      <button
        onClick={submitReview}
        disabled={loading}
        className="mt-4 bg-palmGreen text-white px-5 py-2 rounded w-full hover:opacity-90 disabled:opacity-50"
      >
        {loading ? "Submitting..." : "Submit Review"}
      </button></>)
      }
      
    </div>
  );
}
